import Image from "next/image";
import React, { useEffect, useState } from "react";
import { GoArrowUpRight } from "react-icons/go";
import { container_classname } from "../new-ui/constants";

interface PaymentProcessCard {
    title: string;
    description: string;
    imageUrl: string;
}

export interface PaymentProcess {
    title: string;
    description?: string;
    ProcessSteps: PaymentProcessCard[];
}

const defaultFAQData: PaymentProcess = {
    title: "How to integrate WhatsApp payments in 4 easy steps?",
    ProcessSteps: [
        {
            title: "Go to Integrations tab",
            description: "Go to Integrations → Payments in the Gallabox Dashboard and select the payment gateway.",
            imageUrl: "/integration/payment-link.png",
        },
        {
            title: "Name your Integration",
            description: "Name your integration and initiate the connection with your payment gateway.",
            imageUrl: "/integration/payment-update.png",
        },
        {
            title: "Authorize Gallabox",
            description: "Permit Gallabox to connect with your preferred payment gateway.",
            imageUrl: "/integration/personalize-broadcast.png",
        },
        {
            title: "Configure the settings",
            description: "Choose your preferred WhatsApp channel and configure it.",
            imageUrl: "/integration/travelcation.png",
        },
    ],
};

const AUTO_ADVANCE_INTERVAL = 7000;

const PaymentStepsAccordion: React.FC<{ paymentStepsData?: PaymentProcess }> = ({ paymentStepsData = defaultFAQData }) => {
    const { title, description, ProcessSteps } = paymentStepsData;
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % ProcessSteps.length);
        }, AUTO_ADVANCE_INTERVAL);

        return () => clearInterval(interval);
    }, [ProcessSteps.length]);

    const toggleAccordion = (index: number) => {
        setCurrentIndex(index);
    };

    return (
        <section className="bg-gray-100 py-20 lg:hidden block">
            <div className={`${container_classname} flex md:flex-row flex-col md:gap-x-24`}>
                <h2
                    className="md:text-6xl text-4xl font-semibold md:w-2/5 w-full
                text-left mb-6 md:mb-0 tracking-wide"
                    style={{ fontFamily: "Degular Display" }}
                >
                    {title}
                </h2>
                {description && <p className="text-xl pt-1">{description}</p>}
                <div className="faq-section md:w-1/2 w-full">
                    {ProcessSteps.map((item, index) => (
                        <div key={index} className={`faq-accordion-item ${currentIndex === index ? "faq-active" : ""}`}>
                            <div className="faq-border-top-animation" />
                            <h3 className="faq-accordion-header text-lg font-medium cursor-pointer flex justify-between my-5" onClick={() => toggleAccordion(index)}>
                                {item.title}
                                <span
                                    className={`${currentIndex === index ? "rotated" : ""}`}
                                    style={{
                                        flexShrink: 0,
                                        transition: "transform 0.4s ease",
                                    }}
                                >
                                    <GoArrowUpRight />
                                </span>
                            </h3>
                            {currentIndex === index && (
                                <div className="faq-accordion-content mb-5">
                                    <p className="mt-2">{item.description}</p>
                                    <Image src={item.imageUrl} width={300} height={300} alt={"proceed to integrates"} className="mt-5" />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PaymentStepsAccordion;
